import { createIcon } from '../icon'
import SlimBottomArrowIcon from '../svg/SlimBottomArrowIcon'

export const SlimBottomArrowIconDefault = createIcon(SlimBottomArrowIcon)
